import * as yup from 'yup';

export const CreateClassroomFormValidation = yup.object().shape({
    description: yup.string().required('descrição da sala é obrigatória'),
    idClassroomType: yup.string().required('Tipo da sala é obrigatório'),
    idDepartament: yup.string().required('Departamento é obrigatório'),
    idFaculty: yup.string().required("Unidade orgânica é obrigatória"),
});